import React from 'react';
import ProductPage from './ProductPage';

export default function TotalProtectionSuite() {
  return (
    <ProductPage
      badge="◉ Total Protection Suite"
      title="One shield for"
      titleAccent="every paid and organic channel"
      subtitle="ClickSaver's full stack protects your ads, forms, and analytics from a single dashboard. Fraud blocked in real time, verdicts synced to every platform, campaign quality kept honest."
      features={[
        { icon: '⛉', title: 'PPC click-fraud blocking', body: 'Real-time verdicts on every paid click from Google Ads, Meta, and Microsoft Ads.' },
        { icon: '◍', title: 'Bot &amp; crawler defence', body: 'Catches scrapers and automation that never touch an ad but still pollute your analytics.' },
        { icon: '⤶', title: 'Lead-form fraud shield', body: 'Scores every form submission and blocks fake leads before they reach your CRM.' },
        { icon: '◆', title: 'Pixel protection', body: 'Prevents tags from firing on flagged sessions so your conversion data stays clean.' },
        { icon: '🚨', title: 'Real-time spike alerts', body: 'Email + Slack ping the moment any campaign crosses your fraud-rate threshold. Catch attacks before they drain budget.' },
        { icon: '▦', title: 'Agency-ready reporting', body: 'White-label PDFs with your branding, scheduled emails, per-client access controls.' },
      ]}
      stats={[
        { value: '2,000+', label: 'tests per visit' },
        { value: '<1s', label: 'verdict latency' },
        { value: '15–25%', label: 'average ad spend saved' },
        { value: '10,000+', label: 'advertisers protected' },
      ]}
      ctaTitle="Protect every channel in one place"
      ctaBody="Install once, cover PPC, bots, forms, and analytics. Set up in under 5 minutes."
    />
  );
}
